module.exports = __webpack_public_path__ + "static/img/14-2.04d0543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/14-2.jpg
// module id = gUII
// module chunks = 0